import {
  fallbackSchema,
  recoverConfigSchema,
} from "@redotech/redo-marketing-templates-common/recover-config";
import { objectId } from "@redotech/rpc/ext";
import * as z from "zod";

export const updateRecoverConfig = {
  name: "updateRecoverConfig" as const,
  input: z.object({
    id: z.string(),
    name: z.string().optional(),
    discountId: objectId().nullish(),
    brandName: z.string().optional(),
    agentOutreachEnabled: z.boolean().optional(),
    outreachTemplate: z.string().optional(),
    /** Null routes all replies to `fallback`. */
    replyTemplate: z.string().nullish(),
    fallback: fallbackSchema.optional(),
    ageGateYears: z.number().int().positive().nullable().optional(),
  }),
  output: recoverConfigSchema,
};
